import CashProcessingBatchSearchRequestBase from './base/CashProcessingBatchSearchRequestBase';

/**
 * @class CashProcessingBatchSearchRequest
 * @extends CashProcessingBatchSearchRequestBase
 */
class CashProcessingBatchSearchRequest extends CashProcessingBatchSearchRequestBase {

}

export default CashProcessingBatchSearchRequest;
